import { Component, Inject } from '@angular/core';
import { Events } from "ionic-angular";

import { Observable } from 'rxjs/Observable';
import { EventService } from '../providers/event-service/event-service';
import { GuestService } from '../providers/guest-service/guest-service';

import { EventModel } from '../app/models/event-model';
import { GuestModel } from '../app/models/guest-model';
import { GuestGroupModel } from '../app/models/guestgroup-model';

/* inspired form https://devdactic.com/login-ionic-2/ */
@Component({})
export class RestrictedAccessManager {

  //current session data  //FIXME: NavParam?
  private currentEvent : EventModel;
  private currentGuest : GuestModel;
  private currentGuestGroup : GuestGroupModel;

  constructor(readonly events: Events,
              @Inject("EventService") readonly eventService : EventService,
              @Inject("GuestService") readonly guestService: GuestService) {
    this.currentEvent = null;
    this.currentGuest = null;
    this.currentGuestGroup = null;
	}

  public getEvent() : EventModel {
    return this.currentEvent;
  }

  public getGuest() : GuestModel {
    return this.currentGuest;
  }

  public getGuestGroup() : GuestGroupModel {
    return this.currentGuestGroup;
  }

  public showLogin(): void {
    this.events.publish("nav:login");
  }

  public showPage(link: string): void {
    this.showPageWithData(link, {});
  }

  public showPageWithData(link: string, data: any): void {
    this.events.publish("nav:page",{link:link,data:data});
  }

	public ngOnInit() {//FIXME: replace with ionViewCanEnter? see https://forum.ionicframework.com/t/how-to-use-ionviewcanenter-with-an-observable/69304/3
    this.showLoading();
    this.checkAccess()
    .subscribe(allowed => {
      if(allowed) {
        setTimeout(() => {
          this.hideLoading();
          this.initAfterLoading();
        });
      } else {
        setTimeout(() => {
          this.hideLoading();
          this.doWhenNotAllowed();
        });
      }
    },
    error => {
        this.showError(error);
    });
  }

  public checkAccess() : Observable<boolean> {
    //FIXME: return a Promise (synchronous) instead
    return Observable.create(observer => {
      if(!this.eventService.isEventSelected()) {
        console.warn("No event is selected!");
        observer.next(false);
        observer.complete();
      } else {
        let event = this.eventService.getCurrentEvent();
        let isLoggedIn : boolean = this.guestService.isLoggedIn();
        let currentGuest = this.guestService.getCurrentGuest();
        let allowed = isLoggedIn && this.isAccessAllowed(event, currentGuest);
        if (allowed) {
          //TODO: user data as NavParam? or session?
          this.currentEvent = event;
          this.currentGuest = currentGuest;
          this.currentGuestGroup = this.guestService.getCurrentGuestGroup();
        } else {
          this.currentEvent = null;
          this.currentGuest = null;
          this.currentGuestGroup = null;
        }
        observer.next(allowed);
        observer.complete();
      }
    });
	}

  private isAccessAllowed(event: EventModel, guest: GuestModel) : boolean {
    return this.isEventAllowed(event) && this.isGuestAllowed(event, guest);
  }

  private isEventAllowed(event : EventModel) : boolean {
    return event !== null;
  }

  private isGuestAllowed(event : EventModel, guest : GuestModel) : boolean {
    return guest != null && guest.getEventCode().value === event.code.value;
  }

  //public abstract initAfterLoading();//FIXME: uncomment when inheritance works
  public initAfterLoading() {//FIXME: remove method when inheritance works
  }

  public doWhenNotAllowed() {
    console.warn("Access denied. Redirecting to LoginPage");
    this.showLogin();
  }

  private showLoading() {
    this.events.publish("loading:show");
  }

  private hideLoading() {
    this.events.publish("loading:hide");
  }

  public showError(text : string) : void {
    this.events.publish("error", text);
  }
}


// WEBPACK FOOTER //
// ./src/pages/restrictedaccess.ts